<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t('productPerEntrepotList'))"
      icon="mdi-cog-transfer-outline"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        v-if="!isMobile && !isTablet"
        :data="excelItems"
        worksheet="abriron.com"
        name="data.xls"
        type="xls"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      </template>
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="reportProcessingListColumnPlugins"
        v-column-drag="reportProcessingListColumnPlugins"
        v-column-pin="reportProcessingListColumnPlugins"
        v-model="selected"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        :headers="tableHeaders"
        :items="items"
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :loading="false"
        :page.sync="page"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-0"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                class="pl-action-cell__btn"
                v-bind="attrs"
                icon
                x-small
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                @click="turnover(item, null)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-recycle-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('productTurnover')" />
              </v-list-item>
              <v-list-item
                link
                @click="turnoverCount(item, null)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-ballot-recount-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('productCountTurnover')" />
              </v-list-item>
              <v-list-item
                link
                @click="turnoverAmount(item, null)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-chart-gantt</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('productAmountTurnover')" />
              </v-list-item>
            </v-list>
          </v-menu>
          <span class="pl-action-cell__row">
            <a @click="edit(item)">{{
              parseInt(items.indexOf(item)) + parseInt(from)
            }}</a>
          </span>
          </div>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.sumProcessinig="{ item }">
          {{$numberFormat(item.sumProcessinig)}}
        </template>
        <template v-slot:item.sumReturnProcessinig="{ item }">
          {{$numberFormat(item.sumReturnProcessinig)}}
        </template>
        <template v-slot:item.sumEntrepotProcessing="{ item }">
          <a @click="edit(item)">
            {{ $numberFormat(parseFloat(item.price)) }} {{ $store.state.currencySymbol }}
          </a>
        </template>
        <template v-slot:item.name="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                color="primary"
                text
                small
                v-on="on"
                @click="edit(item)"
              >
                {{ item.name }}
              </v-btn>
              <v-chip
                v-if="item.status != 'active'"
                outlined
                color="pink"
                small
              >
                {{ $t('deactive') }}
              </v-chip>
            </template>
            <span>{{ $t('edit') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.product.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.product.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t('productPerEntrepotList'))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t('productPerEntrepotList'))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
        <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ $t("reportProcessingProductCostFilterTitle") }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-warehouse</v-icon>
              {{ $t("entrepotFilterMain") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="entrepot"
                :title="$t('entrepot')"
                type="entrepot"
                :multiple="true"
                :filter="true"
              />
              <v-select
                v-model="productStatus"
                :label="$t('status')"
                :items="productStatusItems"
                dense
                outlined
                multiple
                clearable
                hide-details
                item-value="value"
                item-text="text"
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum((productStatus || []).length - 1) }}
                  </span>
                </template>
              </v-select>
              <v-select
                v-model="inventoryStatus"
                :label="$t('inventoryStatus')"
                :items="inventoryStatusItems"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="text"
              />
              <tag v-model="tag" />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-shape-outline</v-icon>
              {{ $t("productEntrepotFilterGroups") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="group"
                :title="$t('main-group')"
                type="productGroup"
                :data="JSON.stringify({parent:null,type:'group'})"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="cat1"
                :title="$t('other-group')"
                type="productGroup"
                :data="JSON.stringify({parent:null,type:'category'})"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="cat2"
                title="category"
                type="productGroup"
                :data="JSON.stringify({parent:null,type:'subcategory'})"
                :multiple="true"
                :filter="true"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-calendar-range</v-icon>
              {{ $t("accFilterDateTime") }}
            </div>
            <div class="acf-grid acf-grid--4">
              <div>
                <v-text-field
                  id="fromId"
                  v-model="fromDate"
                  :label="$t('from') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDate"
                  element="fromId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toId"
                  v-model="toDate"
                  :label="$t('until') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDate"
                  element="toId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <autocomplete
                v-model="branch"
                title="branch"
                type="branch"
                :filter="true"
                :multiple="true"
              />
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-group</v-icon>
              {{ $t("reportFilterGrouping") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <div class="acf-switch">
                <span class="acf-switch__label">{{ $t("groupPerEntrepot") }}</span>
                <v-switch
                  v-model="groupPerEntrepot"
                  class="acf-switch__control mt-0 pt-0"
                  value="active"
                  color="primary"
                  dense
                  inset
                  hide-details
                  :ripple="false"
                />
              </div>
              <div class="acf-switch">
                <span class="acf-switch__label">{{ $t("groupPerProductGroup") }}</span>
                <v-switch
                  v-model="groupPerProductGroup"
                  class="acf-switch__control mt-0 pt-0"
                  value="active"
                  color="primary"
                  dense
                  inset
                  hide-details
                  :ripple="false"
                />
              </div>
            </div>
          </section>

          <section v-if="!isMobile && customFieldsPermission" class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-form-textbox</v-icon>
              {{ $t("sellFilterCustom") }}
            </div>
            <custom-fields
              v-model="customFields"
              :value="customFields"
              type-prop="productCustomFields"
              :multiple="true"
            />
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                :loading="loading"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="product"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  import Upload from '../../components/general/upload/upload'
  import customFields from '../../components/general/customFields/index.vue'
  import ProList from "@/Mixins/proList";
  import ProListFrame from "@/components/proList/ProListFrame.vue";
  import ProListMobile from "@/components/proList/ProListMobile.vue";
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  export default {
    name: 'ProductPerEntrepotList',
    components: {
      ProListFrame,
      ProListMobile,
      PrintStudio,
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      customFields,
      Upload,
      Print,
    },
    mixins: [General, ProList],
    props: ['input', 'type', 'refId', 'productProp'],
    data: () => ({
      selected: [],
      pageCount: 1,
      page: 1,
      groupPerEntrepot: null,
      groupPerProductGroup: null,
      customFields: null,
      inventoryStatus: null,
      inventoryStatusItems: null,
      fromDate: null,
      toDate: null,
      group: null,
      cat1: null,
      cat2: null,
      entrepot: null,
      registerar: null,
      selectedHeaders: [],
      uploadDialog: false,
      printDialog: false,
      deletDialog: false,
      showSelect: false,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      // Table pagination options. Kept separate from `options` because the
      // General mixin reuses `options` for money formatting and can overwrite it.
      // This page intentionally uses 5 items per page (see mounted).
      tableOptions: {
        page: 1,
        itemsPerPage: 5,
      },
      headers: null,
      listViewportObserver: null,
      listViewportRaf: null,
      // excelItems: [],
      search: null,
    }),
    computed: {

      activeFilterChips () {
        var app = this
        var has = function (v) {
          if (Array.isArray(v)) return v.length > 0
          return v !== null && v !== undefined && v !== '' && v !== '0' && v !== 0
        }
        var show = function (v) {
          if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0])
          if (v && typeof v === 'object') return v.name || v.text || v.label || ''
          return typeof v === 'number' || typeof v === 'string' ? String(v) : ''
        }
        var pick = function (items, v, key) {
          var arr = Array.isArray(v) ? v : [v]
          return arr
            .map(function (x) {
              var f = (items || []).find(function (i) { return i.value === x })
              return f ? f[key || 'text'] : ''
            })
            .filter(Boolean)
            .join('، ')
        }
        var defs = [
          ['entrepot', app.$t('entrepot')],
          ['productStatus', app.$t('status'), pick(app.productStatusItems, app.productStatus)],
          ['inventoryStatus', app.$t('inventoryStatus'), pick(app.inventoryStatusItems, app.inventoryStatus)],
          ['tag', app.$t('tag')],
          ['group', app.$t('main-group')],
          ['cat1', app.$t('other-group')],
          ['cat2', app.$t('category')],
          ['fromDate', app.$t('from') + ' ' + app.$t('date')],
          ['toDate', app.$t('until') + ' ' + app.$t('date')],
          ['branch', app.$t('branch')],
          ['groupPerEntrepot', app.$t('groupPerEntrepot'), app.groupPerEntrepot === 'active' ? app.$t('groupPerEntrepot') : ''],
          ['groupPerProductGroup', app.$t('groupPerProductGroup'), app.groupPerProductGroup === 'active' ? app.$t('groupPerProductGroup') : ''],
          ['customFields', app.$t('sellFilterCustom')],
        ]
        return defs
          .filter(function (d) { return has(app[d[0]]) })
          .map(function (d) {
            return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) }
          })
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      isDesktopListViewport () {
        return !this.isMobile && !this.isTablet && !this.mobileShow
      },
      reportProcessingListColumnPersistKey () {
        return 'report-processing-list-columns-' + (this.$route.name || 'reportProcessingProductCost')
      },
      reportProcessingListLockedColumns () {
        var locked = ['actions']
        return this.showSelect ? ['__select'].concat(locked) : locked
      },
      reportProcessingListColumnPlugins () {
        var selectHeader = {
          value: '__select',
          text: '',
          width: 32,
          sortable: false,
          pinned: false,
          originalIndex: -1,
        }
        var visible = this.showSelect
          ? [selectHeader].concat(this.showHeaders || [])
          : this.showHeaders || []
        return {
          headers: this.headers,
          visibleHeaders: visible,
          locked: this.reportProcessingListLockedColumns,
          anchor: 'actions',
          minWidth: 60,
          persistKey: this.reportProcessingListColumnPersistKey,
        }
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.typeForm === 'service') {
            if (s.value === 'stock' || s.value === 'order_point') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            if ((app.groupPerProductGroup || app.groupPerEntrepot) && (s.value === 'name' || s.value === 'code' || s.value === 'unit.fame')) {
            } else {
              return app.selectedHeaders.includes(s)
            }
          }
        })
      },
      excelItems: function () {
        var app = this
        var list = []
        if (this.items && this.items.length) {
          this.items.map((d, index) => {
            list.push({
              type: app.$t(d.type),
              id: d.product.id,
              uid: d.product.uid,
              name: d.product.name,
              code: d.product.code,
              barcode: d.product.barcode,
              branch: app.branch,
              order_point: d.product.order_point,
              entrepot: (d.entrepot ? d.entrepot.name : ''),
              unit: (d.unit ? d.unit.fame : ''),
              count_in: +d.count_in,
              count_out: +d.count_out,
              count_remain: +d.count_in - +d.count_out,
              price_in: +d.price_in,
              price_out: +d.price_out,
              price_remain: +d.price_in - +d.price_out,
              user: (d.user ? d.user.name : ''),
            })
          })
        }
        return list
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          ;(app.tableOptions.sortBy || []).map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            if (index > -1) {
              app.sortBy.push(app.headers[index].table)
            }
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      loading (val) {
        if (!val && this.isDesktopListViewport) {
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        }
      },
      isDesktopListViewport (val) {
        if (val) {
          this.$nextTick(() => {
            this.updateDesktopTableHeight()
            this.bindListViewportObserver()
          })
        } else {
          this.unbindListViewportObserver()
          this.tableHeight = window.innerHeight - 245
        }
      },
    },
    activated () {
      this.getItems()
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver()
          this.scheduleDesktopTableHeightUpdate()
        })
      }
    },
    beforeMount () {
      this.typeForm = 'product'
      this.headers = [
        {
          text: this.$t('#'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 42,
          class: 'pl-action-col',
          cellClass: 'pl-action-col',
        },
        {
          text: this.$t('name'),
          sortable: true,
          value: 'name',
          table: 'products.name',
        },
        {
          text: this.$t('code'),
          sortable: true,
          value: 'code',
          table: 'products.code',
        },
        {
          text: this.$t('unit'),
          sortable: false,
          value: 'unit.fame',
        },
        {
          text: this.$t('main-group'),
          sortable: false,
          value: 'product.group.name',
        },
        {
          text: this.$t('other-group'),
          sortable: false,
          value: 'product.cat1.name',
        },
        {
          text: this.$t('category'),
          sortable: false,
          value: 'product.cat2.name',
        },
        {
          text: this.$t('entrepot'),
          sortable: false,
          value: 'entrepot_name',
        },
        {
          text: this.$t('sumInCount'),
          sortable: false,
          value: 'count_in',
        },
        {
          text: this.$t('sumEntrepotProcessing'),
          sortable: false,
          value: 'sumProcessinig',
        },
        {
          text: this.$t('sumEntrepotReturnProcessing'),
          sortable: false,
          value: 'sumReturnProcessinig',
        },
      ]
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      this.inventoryStatusItems = [
        {
          value: '>',
          text: this.$t('available'),
        },
        {
          value: '=',
          text: this.$t('unavailable'),
        },
        {
          value: '<',
          text: this.$t('negetive'),
        },
        {
          value: 'orderpoint',
          text: this.$t('orderpoint'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      reorderPinnedHeaders(this.headers, {
        locked: this.reportProcessingListLockedColumns,
        anchor: 'actions',
      })
      this.loadReportProcessingListColumnSettings()
    },
    mounted () {
      // Preserve existing page size for this report (was options.itemsPerPage = 5)
      this.tableOptions.itemsPerPage = 5
      this.getItems()
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver()
          this.updateDesktopTableHeight()
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        })
      }
    },
    deactivated () {
      this.unbindListViewportObserver()
    },
    beforeDestroy () {
      this.unbindListViewportObserver()
      if (this.listViewportRaf) {
        cancelAnimationFrame(this.listViewportRaf)
        this.listViewportRaf = null
      }
    },
    methods: {

      resetFilters () {
        var app = this
        ;[
          'entrepot', 'productStatus', 'inventoryStatus', 'tag',
          'group', 'cat1', 'cat2', 'fromDate', 'toDate', 'branch',
          'groupPerEntrepot', 'groupPerProductGroup', 'customFields',
        ].forEach(function (k) { app[k] = null })
      },
      resolveRefEl (ref) {
        if (!ref) return null
        return ref.$el || ref
      },
      onResize () {
        if (this.isDesktopListViewport) {
          this.updateDesktopTableHeight()
          return
        }
        this.tableHeight = window.innerHeight - 245
      },
      scheduleDesktopTableHeightUpdate () {
        if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf)
        this.listViewportRaf = requestAnimationFrame(() => {
          this.listViewportRaf = null
          this.updateDesktopTableHeight()
        })
      },
      updateDesktopTableHeight () {
        if (!this.isDesktopListViewport) {
          this.tableHeight = window.innerHeight - 245
          return
        }
        const rootEl = this.resolveRefEl(this.$refs.listRoot)
        const toolbarEl = this.resolveRefEl(this.$refs.listToolbar)
        const summaryEl = this.resolveRefEl(this.$refs.listSummary)
        const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
        const tableEl = this.resolveRefEl(this.$refs.listTable)
        if (!rootEl || !tableColEl) {
          this.tableHeight = window.innerHeight - 245
          return
        }
        const rootStyle = window.getComputedStyle(rootEl)
        const rootPadding =
          (parseFloat(rootStyle.paddingTop) || 0) +
          (parseFloat(rootStyle.paddingBottom) || 0)
        const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0
        let summaryHeight = 0
        if (summaryEl) {
          const summaryVisible =
            summaryEl.offsetParent !== null ||
            summaryEl.getClientRects().length > 0
          if (summaryVisible) {
            const summaryStyle = window.getComputedStyle(summaryEl)
            summaryHeight =
              summaryEl.offsetHeight +
              (parseFloat(summaryStyle.marginTop) || 0) +
              (parseFloat(summaryStyle.marginBottom) || 0)
          }
        }
        const colStyle = window.getComputedStyle(tableColEl)
        const colPadding =
          (parseFloat(colStyle.paddingTop) || 0) +
          (parseFloat(colStyle.paddingBottom) || 0)
        const footerEl = tableEl
          ? tableEl.querySelector('.v-data-footer')
          : null
        const footerHeight = footerEl ? footerEl.offsetHeight : 0
        const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null
        const tableMargins = tableStyle
          ? (parseFloat(tableStyle.marginTop) || 0) +
            (parseFloat(tableStyle.marginBottom) || 0)
          : 0
        const available =
          rootEl.clientHeight -
          rootPadding -
          toolbarHeight -
          summaryHeight -
          colPadding -
          footerHeight -
          tableMargins -
          3
        this.tableHeight = Math.max(180, Math.floor(available))
      },
      bindListViewportObserver () {
        if (typeof ResizeObserver === 'undefined') return
        this.unbindListViewportObserver()
        const rootEl = this.resolveRefEl(this.$refs.listRoot)
        const summaryEl = this.resolveRefEl(this.$refs.listSummary)
        const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
        const tableEl = this.resolveRefEl(this.$refs.listTable)
        const footerEl = tableEl ? tableEl.querySelector('.v-data-footer') : null
        if (!rootEl && !tableColEl) return
        this.listViewportObserver = new ResizeObserver(() => {
          this.scheduleDesktopTableHeightUpdate()
        })
        if (rootEl) this.listViewportObserver.observe(rootEl)
        if (summaryEl) this.listViewportObserver.observe(summaryEl)
        if (tableColEl) this.listViewportObserver.observe(tableColEl)
        if (footerEl) this.listViewportObserver.observe(footerEl)
      },
      unbindListViewportObserver () {
        if (this.listViewportObserver) {
          this.listViewportObserver.disconnect()
          this.listViewportObserver = null
        }
      },
      loadReportProcessingListColumnSettings () {
        var app = this
        if (!app.headers || !app.headers.length) return
        loadColumnSettings(app, app.reportProcessingListColumnPersistKey).then(function (snapshot) {
          if (!snapshot || !snapshot.length) return
          applyColumnSettings(app.headers, snapshot, {
            locked: app.reportProcessingListLockedColumns,
            anchor: 'actions',
          })
          app.$forceUpdate()
        })
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openUploadDialog (item) {
        this.uploadDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'ProductEdit', params: { id: item.productId } })
      },
      turnover (item) {
        this.$router.push({ name: 'productTurnoverSingle', params: { id: item.productId, entrepotProp: item.entrepot_id, tabName: item.product.name } })
      },
      turnoverCount (item, entrepot) {
        this.$router.push({ name: 'productCountTurnover', params: { productProp: item, entrepotProp: entrepot } })
      },
      turnoverAmount (item, entrepot) {
        this.$router.push({ name: 'productAmountTurnover', params: { productProp: item, entrepotProp: entrepot } })
      },
      getItems () {
        var app = this
        app.loading = true
        var productId = (app.productProp ? app.productProp.id : null)
        productId = (this.$route.params.id ? this.$route.params.id : productId)
        app.$axios.get(this.$endpoint + 'productsreport', {
          params: {
            report: 'processing',
            groupPerEntrepot: app.groupPerEntrepot,
            groupPerProductGroup: app.groupPerProductGroup,
            inventoryStatus: app.inventoryStatus,
            productId: productId,
            entrepot: app.entrepot,
            customFields: app.customFields,
            group: app.group,
            cat1: app.cat1,
            cat2: app.cat2,
            fromDate: app.fromDate,
            toDate: app.toDate,
            registerar: app.registerar,
            branch: app.branch,
            search: app.search,
            page: app.tableOptions.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.pageCount = res.last_page
            app.from = res.from
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'products/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push({ id: value.id })
        })
        app.$axios.get(this.$endpoint + 'products', {
          params: {
            deleteItems: selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";


</style>
